import React, { Component } from 'react';
import '../myutils';
import Card from '@material-ui/core/Card';
import { translate } from 'react-admin';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Trans from '../res/Trans'
import { TextInput, SimpleForm } from 'react-admin';
import ReactHTMLTableToExcel from './ReactHTMLTableToExcel-master';


const style = { flex: 1, maxHeight: 700, overflow: 'auto' };

class ShowCalls extends Component {
  constructor() {
    super()
    this.state = {
      selectOptions: [],
      table2save: [],
      table2: []
    }
  }

  componentDidMount() {
    this.setState({ table2save: this.props.table2 });
    this.setState({ table2: this.props.table2 });
  }

  handleSearch = (e) => {
    var search = e.target.value;
    var table = this.state.table2save;
    const result = table.filter(arr => arr.some(function (v) { return v.indexOf(search) >= 0 }));
    this.setState({ table2: result });

  }


  render() {
    const { translate, table1, header1, header2 } = this.props;
    return (
      <div id="LogTable" >
        <Card style={style}>
          <div id="ButtonSearch" style={{ float: "left" }}>
            <SimpleForm toolbar={false}>
              <ReactHTMLTableToExcel
                id="table-xls-button"
                className="waves-effect waves-light btn"
                table="tableA,tableB"
                filename="Stats"
                sheet="tablexls"
                buttonText={translate('trans.download_log')}
              />
              <TextInput label={translate('trans.search')} onChange={this.handleSearch} />
            </SimpleForm>
          </div>
          <Table id="tableA" ><TableHead><TableRow>
            {header1.map(H1 => (
              <TableCell><Trans locale='en' text={H1} /></TableCell>))}
          </TableRow></TableHead><TableBody>
              {table1.map(T1 => (
                <TableRow>
                  {T1.map(data => (
                    <TableCell>{data}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody></Table>
          <Table id="tableB" ><TableHead><TableRow>
            {header2.map(H2 => (
              <TableCell><Trans locale='en' text={H2} /></TableCell>))}
          </TableRow></TableHead><TableBody>
              {this.state.table2.map(T2 => (
                <TableRow>
                  {T2.map(data => (
                    <TableCell>{data}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      </div>
    )
  };
}
export default translate(ShowCalls);
